import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export default function useRouteHelper() {

  const ROOT_PATH = '/';

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = location;


  // ---functions
  const getParentPath = () => {

    let parentPath = ROOT_PATH;
    parentPath = pathname.substring(0, pathname.lastIndexOf('/'));
    if (!parentPath.endsWith('/')) { parentPath += '/'; }

    // if (pathname !== ROOT_PATH) {
    //   const paths = pathname.split(ROOT_PATH);
    //   parentPath = `${ROOT_PATH}${(paths.length === 1 ? paths[0] : paths[1])}${ROOT_PATH}`;
    // }

    // ---
    return parentPath;
  }



  // ---paths
  const gotoUrl = (url: string) => navigate(url);
  const goBack = () => navigate(-1);
  const gotoParent = () => navigate(getParentPath());

  // ---Utils
  const gotoUrlOrHome = (url?: string) => url ? gotoUrl(url) : gotoParent();
  const gotoUrlOrBack = (url?: string) => url ? gotoUrl(url) : goBack();

  // module-paths
  // ---authentication paths
  const gotoAuthenticationPage = () => navigate(getParentPath() + 'login');

  // --- public paths

  // --- private paths
  // const gotoUserPage = () => navigate('/user');
  const gotoUserPage = () => navigate('/user/reporting-and-analytics/report-list');

  // ------ Modules
  const gotoGrossToNetPage = () => navigate(getParentPath() + 'gross-to-net');
  const gotoQueuedReportsPage = () => navigate(getParentPath() + 'queued-reports');
  const gotoForecastingPage = () => navigate(getParentPath() + 'forecasting');

  // ------ Reports
  const gotoReportingAndAnalyticsPage = () => navigate(getParentPath() + 'reporting-and-analytics');
  const gotoReportListPage = () => navigate(getParentPath() + 'report-list');
  const gotoReportDataPage = () => navigate(getParentPath() + 'report-data');


  // ---
  return {
    location, navigate, pathname, searchParams, setSearchParams,
    // utils
    gotoUrlOrHome, gotoUrlOrBack,
    // root-routes
    gotoUrl, goBack, gotoParent,
    // common-routes
    gotoAuthenticationPage,

    // private-routes
    gotoUserPage,
    gotoGrossToNetPage, gotoForecastingPage, gotoQueuedReportsPage,
    // ---Reporting-And-Analytics
    gotoReportingAndAnalyticsPage, gotoReportListPage, gotoReportDataPage

  }

}
